import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "@/i18n/translations";
import { devWarn } from "@/lib/log";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("serava_lang") || "sv");

  useEffect(() => {
    // Detect language from IP on first visit
    if (localStorage.getItem("serava_lang")) return;
    const detect = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/", { signal: AbortSignal.timeout(3000) });
        const data = await res.json();
        const nordicCountries = ["SE", "NO", "DK", "FI", "IS"];
        if (data.country_code && !nordicCountries.includes(data.country_code)) {
          setLangState("en");
          localStorage.setItem("serava_lang", "en");
        }
      } catch (err) {
        devWarn("Geolocation detection failed, keeping default Swedish:", err.message);
      }
    };
    detect();
  }, []);

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    localStorage.setItem("serava_lang", newLang);
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations.sv[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
export default LanguageContext;
